<ng-content select="baas-field, baas-icon-text"></ng-content>
